import { CookWidget } from '@widgets/types'
import { FunctionComponent } from 'react'
import MultipleAuthors from './MultipleAuthors'
import SingleAuthorWrapper from './SingleAuthorWrapper'
import { AuthorProps } from './types'

interface AuthorAPIProps {
  authors: AuthorProps[]
}

const Author: FunctionComponent<AuthorAPIProps> = ({ authors }) => {
  if (!authors?.length) {
    return null
  }
  const isSingleAuthor = authors.length === 1

  return isSingleAuthor ? (
    <SingleAuthorWrapper>{authors[0]}</SingleAuthorWrapper>
  ) : (
    <MultipleAuthors>{authors}</MultipleAuthors>
  )
}

const widget: CookWidget = {
  kind: ['widget', 'inlineElement', 'author'],
  component: Author,
}

export default widget
